import { Pipe, PipeTransform } from '@angular/core';

import { RoomsOperatingStateReason } from '@vi-iot/client/index';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateOperatingState',
})
export class TranslateOperatingStatePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(reason: string, level: string): string {
    if (
      reason === RoomsOperatingStateReason.noDemand ||
      reason === RoomsOperatingStateReason.schedule
    ) {
      return this.translateService.instant(
        this.customTranslationsService.OPERATING_STATE_LEVEL[level] ?? level
      );
    }
    if (reason && this.customTranslationsService.OPERATING_STATE_REASON[reason]) {
      return this.translateService.instant(
        this.customTranslationsService.OPERATING_STATE_REASON[reason] ?? reason
      );
    }

    return reason;
  }
}
